var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-tips"},[_c('p',{staticClass:"tips ellipsis3"},[_vm._t("default")],2),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"domain"},[_c('i',{staticClass:"iconfont icon-a-close-line1"}),_vm._v(" https://www.kakaclo.com ")])
}]

export { render, staticRenderFns }